export default {
  name: "ReputationComment",
  components: {},
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    review: {
      type: Object,
      default: null,
    },
  },
  components: {},
  mounted() {},
  data() {
    return {}
  },
  methods: {
    show() {
      this.display = true
    },
    hide() {
      this.display = false
    },
  },
  computed: {},
  mounted() {},
  created() {},
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Widget/ReputationData/Comment/ReputationComment.component.js